<template>
  <div>
    <v-dialog
      v-model="showDialog"
      max-width="400px"
      persistent
      :fullscreen="breakpoint.xsOnly"
      :hide-overlay="breakpoint.xsOnly"
    >
      <v-card rounded center>
        <v-toolbar dense flat color="grey darken-3" dark>
          <v-toolbar-title>We found some goodies!!</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <p>It looks like you already have scores or custom exercises stored on your device. They have now been copied to the database and you can access them on any device you log in from.</p>
          <p>If you don't want that, you can reset scores and delete all your exercises from the user account page.</p>
            <v-btn
              color="teal"
              class="mt-2 mb-2"
              block
              dark
              @click="handleClick"
              >Cool!</v-btn
            >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "dataCopiedToDatabaseDialog",
  data() {
    return {

    }
  },
  methods: {
    handleClick() {
      this.showDialog = false;
      window.location.reload(); 
      return false;
    }
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    showDialog: {
      get() {
        return this.$store.getters.getShowDataCopiedToDatabaseDialog;
      },
      set(value) {
        this.$store.dispatch("setShowDataCopiedToDatabaseDialog", value);
      }
    }
  }
}
</script>

<style>

</style>